<!--
 * @Description: 
-->
<template>
    <div>
      <!-- 顶部图片 -->
      <div class="top-pic">
        <img src="../../assets/contact/message-banner.png" alt="">
      </div>
      <div class="content">
        <div class="content-center">
          <div class="title">诚招代理</div>
          <div class="content_detail">
            <p>为拓宽公司销售渠道，满足更多地区的客户对埃诺登产品及服务的需求，埃诺登现向全国各地诚招代理商，合作共赢，共创未来。</p>
            <p>代理商代理条件：</p>
            <p>1、代理商必须为正规注册公司，具有合法的经营资格；</p>
            <p>2、代理商有相对完善的销售网络和渠道，有一定相关的行业客户资源和市场开拓组织能力。</p>
            <p>咨询热线：010-53340557 客服部 王小姐</p>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {};
    }
  };
  </script>
  <style lang="css" scoped>
  .top-pic {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .top-pic img {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-center {
    width: 1000px;
  }
  .title {
    font-size: 20px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 24px;
    border-bottom: 1px solid #eeeeee;
  }
  .content_detail {
    margin: 50px 0;
    padding-left: 10px;
  }
  .content_detail p {
    width: 1015px;
    font-size: 16px;
    line-height: 36px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  .content_detail h4 {
    margin-top: 77px;
  }
  .content_detail li {
    margin-top: 77px;
  }
  .tel {
    font-weight: bold;
    line-height: 30px;
    margin-top: 77px;
    margin-bottom: 77px;
  }
  </style>
  